import http from "@/utils/http";
/**
 * 获取事项列表
 * @returns {*}
 */
export const queryList = (type, flowKey, pageIndex, searchJson, searchFieldJson) => {
    const URL = {
        all: '/cooperativeInst/haveHairList.htm',
        draft: '/cooperativeInst/primedList.htm',
        send: '/cooperativeInst/haveHairList.htm',
        ongoing: '/cooperativeInst/haveHairList.htm',
        end: '/cooperativeInst/haveHairList.htm',
        todo: '/cooperativeInst/toDoList.htm',
        done: '/cooperativeInst/haveToDoList.htm',
        doneOngoing: '/cooperativeInst/queryDoneList.htm',
        doneEnd: '/cooperativeInst/queryDoneList.htm',
        copy: '/cooperativeInst/makeCopeList.htm',
        copyOngoing: '/cooperativeInst/queryCopeList.htm',
        copyEnd: '/cooperativeInst/queryCopeList.htm',
        reply: '/cooperativeInst/newReplayList.htm',
    }

    if (searchJson) searchJson = decodeURIComponent(searchJson)
    if (searchFieldJson) searchFieldJson = decodeURIComponent(searchFieldJson)
    let params = {
        searchFieldJson: searchFieldJson,
        searchJson: searchJson,
        tStatus: type == 'doneOngoing' || type == 'copyOngoing'? 'ongoing' : type == 'doneEnd' || type == 'copyEnd'? 'end' : type,
        flowKey: flowKey.split('&')[0]? flowKey.split('&')[0] : flowKey,
        pageIndex: pageIndex,
        pageSize: 20,
    }
    if (type == 'todo') {
        params.isMobile = true;
    }
    return http.post(URL[type], params)
}
/**
 * 删除流程实例
 * @param id 流程实例id
 * @returns {*}
 */
export const deleteInstance = id => http.get('/cooperative/deleteCooperative.htm', {ids: id})
/**
 * 根据流程查询表单信息实例
 * @param id 流程实例id
 * @returns {*}
 */
export const getFormList = params => http.get('/cooperativesearch/queryForms.htm?id=' + params.id + '&type=' + params.type)
/**
 * 根据表单id查询表单字段实例
 * @param id 表单实例id
 * @returns {*}
 */
export const getWordsList = params => http.get('flowcfg/synergy_field/queryListByFormId.htm?formId=' + params.formId + '&type=query')
/**
 * 批量通过
 * @param ids 表单实例ids
 * @returns {*}
 */
export const batchHandleCooperative = (params) => http.requestByData('cooperative/batchHandleCooperative.htm', 'POST', params);
/**
 * 常用意见
 * @param
 * @returns {*}
 */
export const queryHandleApprovalOpinion = id => http.post('/cooperative/queryHandleApprovalOpinion.htm', {ids: id})
/**
 * 批量完成
 * @param ids 表单实例ids
 * @returns {*}
 * */
export const batchEndCooperative = (params) => http.requestByData('cooperative/batchEndCooperative.htm', 'POST', params);

/**
 * 完成
 * @param id 表单实例id
 * 
 * @returns {*}
 * */
export const checkBatchEnd = (params) => http.get('cooperative/checkBatchEnd.htm?instIds=' + params.instIds);
